<template>
<svg version="1.0" xmlns="http://www.w3.org/2000/svg"
 width="512.000000pt" height="512.000000pt" viewBox="0 0 512.000000 512.000000"
 preserveAspectRatio="xMidYMid meet">

    <g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
    fill="currentColor" stroke="none">
    <path d="M875 4721 c-16 -4 -40 -13 -51 -19 -38 -20 -103 -103 -111 -141 -5
    -20 -8 -145 -8 -278 l0 -241 -265 -4 c-293 -4 -307 -7 -369 -69 -67 -67 -71
    -84 -71 -374 0 -286 4 -307 66 -369 65 -64 76 -66 371 -66 l268 0 0 -255 0
    -255 -265 0 c-236 0 -269 -2 -306 -19 -49 -23 -107 -88 -122 -140 -16 -52 -16
    -510 -1 -562 17 -55 65 -108 123 -135 49 -23 59 -24 311 -24 l260 0 0 -250 0
    -250 -237 0 c-131 0 -259 -5 -287 -11 -70 -15 -123 -57 -155 -122 l-27 -54 3
    -264 c3 -245 5 -267 24 -304 25 -48 90 -100 142 -115 24 -6 254 -10 637 -10
    l600 0 53 25 52 24 38 -22 c37 -22 38 -22 650 -25 l614 -3 52 24 52 24 40 -21
    c39 -21 47 -21 669 -21 711 0 657 -6 734 81 22 26 44 62 48 83 5 20 8 145 8
    278 l0 241 265 4 c253 3 267 4 312 26 25 13 58 39 73 58 53 69 55 84 55 361 0
    284 -4 305 -66 367 -65 64 -76 66 -371 66 l-268 0 0 255 0 255 265 0 c301 0
    317 4 381 79 54 63 59 91 59 361 0 278 -5 305 -65 366 -69 68 -100 74 -394 74
    l-256 0 3 245 c2 155 -1 260 -8 286 -14 50 -73 116 -125 140 -35 16 -70 19
    -305 19 l-265 0 0 258 c0 231 -2 261 -19 295 -26 53 -97 112 -151 126 -30 7
    -234 11 -638 11 l-594 0 -48 -25 -49 -24 -35 22 -36 22 -615 2 c-338 1 -628
    -2 -645 -6z m1224 -195 c8 -9 11 -83 9 -247 l-3 -234 -594 -3 c-430 -1 -598 1
    -607 9 -11 9 -14 58 -14 231 0 132 4 227 10 239 10 18 28 19 599 19 487 0 591
    -2 600 -14z m1410 0 c8 -9 11 -83 9 -247 l-3 -234 -594 -3 c-430 -1 -598 1
    -607 9 -11 9 -14 58 -14 231 0 132 4 227 10 239 10 18 28 19 599 19 487 0 591
    -2 600 -14z m694 -689 c16 -11 17 -35 15 -247 l-3 -235 -594 -3 c-430 -1 -598
    1 -607 9 -19 16 -20 459 -2 477 18 18 1167 17 1191 -1z m-2804 -11 c8 -9 11
    -82 9 -242 l-3 -229 -605 0 -605 0 -3 230 c-1 126 0 235 2 242 8 20 1189 19
    1205 -1z m1410 0 c8 -9 11 -82 9 -242 l-3 -229 -605 0 -605 0 -3 230 c-1 126
    0 235 2 242 8 20 1189 19 1205 -1z m-710 -680 c8 -9 11 -83 9 -247 l-3 -234
    -595 -3 c-550 -2 -596 -1 -607 15 -16 21 -18 434 -3 464 10 18 28 19 599 19
    487 0 591 -2 600 -14z m1401 -6 c19 -19 20 -33 20 -239 0 -186 -2 -222 -16
    -235 -14 -14 -82 -16 -598 -16 -439 0 -585 3 -594 12 -9 9 -12 77 -12 245 0
    210 2 233 18 242 11 7 219 10 590 11 559 0 572 0 592 -20z m1411 10 c18 -10
    19 -24 19 -237 0 -197 -2 -229 -17 -245 -15 -17 -47 -18 -598 -18 -438 0 -584
    3 -593 12 -9 9 -12 76 -12 239 0 224 0 228 22 243 20 14 93 16 591 16 373 0
    575 -4 588 -10z m-3513 -930 c2 -212 1 -236 -15 -247 -22 -17 -1143 -19 -1174
    -3 -18 10 -19 24 -19 244 0 128 3 236 7 239 3 4 275 6 602 5 l596 -3 3 -235z
    m1400 228 c9 -9 12 -76 12 -240 0 -214 -1 -228 -19 -238 -13 -6 -215 -10 -588
    -10 -498 0 -571 2 -591 16 -22 15 -22 19 -22 243 0 125 3 231 7 234 3 4 272 7
    598 7 446 0 594 -3 603 -12z m1410 0 c17 -17 17 -459 0 -476 -17 -17 -1179
    -17 -1196 0 -17 17 -17 459 0 476 17 17 1179 17 1196 0z m-710 -684 c22 -15
    22 -19 22 -236 0 -192 -2 -224 -17 -240 -15 -17 -47 -18 -598 -18 -438 0 -584
    3 -593 12 -9 9 -12 77 -12 245 0 210 2 233 18 242 11 7 219 10 587 11 501 0
    573 -2 593 -16z m1416 -6 c13 -19 16 -59 16 -233 0 -174 -3 -214 -16 -233
    l-15 -22 -583 0 c-439 0 -585 3 -594 12 -9 9 -12 76 -12 239 0 194 2 230 16
    243 14 14 81 16 594 16 l579 0 15 -22z m-2815 -2 c8 -9 11 -83 9 -247 l-3
    -234 -589 -3 c-538 -2 -591 -1 -608 14 -16 16 -18 36 -18 239 0 158 3 224 12
    233 19 19 1181 17 1197 -2z m-708 -686 c18 -10 19 -23 19 -231 0 -133 -4 -228
    -10 -240 -10 -18 -28 -19 -598 -19 -444 0 -591 3 -600 12 -18 18 -17 474 1
    481 25 11 1168 7 1188 -3z m1413 -6 c14 -13 16 -48 16 -231 0 -187 -2 -219
    -17 -235 -15 -17 -47 -18 -598 -18 -438 0 -584 3 -593 12 -18 18 -17 474 1
    481 6 3 274 6 594 6 516 1 583 -1 597 -15z m1410 0 c12 -31 7 -459 -6 -472
    -17 -17 -1179 -17 -1196 0 -17 17 -17 459 0 476 9 9 157 12 604 12 530 0 592
    -2 598 -16z"/>
    </g>
    </svg>
</template>
